export default function fTextareaInit(){
    const jstextarea = document.querySelectorAll('.js-textarea');
    jstextarea.forEach((textarea, index) => {
        fTextarea(textarea);
        textarea.addEventListener("input", () => {
            setTimeout(()=>{
                fTextarea(textarea);
            },200);
        });
    });

    window.addEventListener("resize", () => {
        const jstextarea = document.querySelectorAll('.js-textarea');
        jstextarea.forEach((textarea, index) => {
            setTimeout(()=>{
                fTextarea(textarea);
            },200);
        });
    });
}

function fTextarea(textarea){
    textarea.style.height = "auto";
    textarea.setAttribute("style", "height:" + (textarea.scrollHeight+2) + "px;overflow-y:hidden;");
    const chat = document.getElementById('js-chat');
    const chatForm = document.querySelector('.chat__form');
    if (typeof chat !== 'undefined' && chat !== null && typeof chatForm !== 'undefined' && chatForm !== null) {
        const formHeight = chatForm.offsetHeight;
        chat.style.setProperty('--chat-bottom', formHeight + "px");
    }
}

document.addEventListener('DOMContentLoaded', () => {
    fTextareaInit();
});
